import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[680px] md:min-h-[720px] flex flex-col" aria-label="首页主视觉">
      {/* Upper: White typography zone */}
      <div className="relative z-10 bg-background-50 pt-28 md:pt-32 pb-10 md:pb-14 px-4 md:px-8 text-center">
        {/* Label bar */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
            <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center" />
            全网最热爆料平台
          </span>
        </div>

        {/* Main title */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-primary-500 leading-tight max-w-4xl mx-auto">
          51app
          <br />
          <span className="text-foreground-700">全网吃瓜第一站</span>
        </h1>

        {/* Subtitle */}
        <p className="mt-5 md:mt-6 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          免费下载安装51app，第一时间获取网红爆料、明星八卦、聊天记录曝光、视频爆料。今日最热吃瓜内容实时更新，让你永远站在吃瓜最前线。
        </p>

        {/* CTA Buttons */}
        <div className="mt-7 md:mt-9 flex items-center justify-center gap-3 md:gap-4">
          <a
            href="#download"
            className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-xl bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-download-line w-5 h-5 flex items-center justify-center" />
            免费下载
          </a>
          <Link
            to="/category/wanghong-baoliao"
            className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-xl border-2 border-primary-500 text-primary-500 text-sm md:text-base font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-fire-line w-5 h-5 flex items-center justify-center" />
            立即吃瓜
          </Link>
        </div>
      </div>

      {/* Lower: Full-bleed image area */}
      <div className="relative flex-1 min-h-[280px] md:min-h-[340px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20editorial%20collage%20of%20celebrity%20paparazzi%20silhouettes%2C%20neon%20warm%20orange%20and%20red%20accents%2C%20social%20media%20bubbles%20and%20gossip%20atmosphere%2C%20cinematic%20lighting%2C%20high%20energy%20mood%2C%20abstract%20digital%20art%20style&width=1600&height=700&seq=hero-collage&orientation=landscape"
          alt="51app 全网吃瓜爆料平台"
          className="absolute inset-0 w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
        <div className="absolute bottom-6 md:bottom-10 left-0 right-0 px-4 md:px-8">
          <div className="flex items-center justify-center gap-4 md:gap-8 text-white/90 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-user-line w-4 h-4 flex items-center justify-center" />
              500万+ 用户
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-article-line w-4 h-4 flex items-center justify-center" />
              10万+ 爆料
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
              日活100万+
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}